// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r7-6";
export var imgContainer = "_r7-3";
export var menuIcon = "_r7-5";
export var pillWrapper = "_r7-2";
export var pillsContainer = "_r7-1";
export var subscriptionCard = "_r7-0";
export var subscriptionLogo = "_r7-4";